const en = {
  // ──────────────────────────────────────────────
  // COMMON
  // ──────────────────────────────────────────────
  'common.loading': 'Loading...',
  'common.saving': 'Saving...',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.status': 'Status',
  'common.actions': 'Actions',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.all': 'All',
  'common.allStatus': 'All Status',
  'common.allClients': 'All Clients',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.page': 'Page',
  'common.of': 'of',
  'common.showing': 'Showing',
  'common.noResults': 'No results found',
  'common.required': 'required',
  'common.optional': 'Optional',
  'common.description': 'Description',
  'common.name': 'Name',
  'common.email': 'Email',
  'common.phone': 'Phone',
  'common.created': 'Created',
  'common.updated': 'Updated',
  'common.viewDetails': 'View Details',
  'common.saveChanges': 'Save Changes',
  'common.addNew': 'Add New',
  'common.exportCsv': 'Export CSV',
  'common.refresh': 'Refresh',
  'common.uploadDocument': 'Upload document',
  'common.uploading': 'Uploading...',
  'common.noDocuments': 'No documents uploaded',
  'common.deleting': 'Deleting...',
  'common.confirmDelete': 'Confirm deletion?',
  'common.thisActionCannotBeUndone': 'This action cannot be undone.',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.details': 'Details',
  'common.preview': 'Preview',
  'common.color': 'Color',
  'common.icon': 'Icon',
  'common.website': 'Website',
  'common.industry': 'Industry',
  'common.location': 'Location',
  'common.contact': 'Contact',
  'common.client': 'Client',
  'common.department': 'Department',
  'common.role': 'Role',
  'common.password': 'Password',
  'common.newPassword': 'New Password',
  'common.permissions': 'Permissions',
  'common.priority': 'Priority',
  'common.category': 'Category',
  'common.type': 'Type',
  'common.value': 'Value',
  'common.total': 'Total',
  'common.date': 'Date',
  'common.notes': 'Notes',
  'common.documents': 'Documents',
  'common.plants': 'Plants',
  'common.contracts': 'Contracts',
  'common.read': 'Read',
  'common.unread': 'Unread',
  'common.na': 'N/A',
  'common.emDash': '—',
  'common.unknown': 'Unknown',
  'common.unassigned': 'Unassigned',
  'common.system': 'System',
  'common.paginationRange': 'Showing {{from}}–{{to}} of {{total}}',
  'common.pageOf': 'Page {{page}} of {{totalPages}}',
  'common.idLabel': 'ID: {{id}}',
  'common.searchLabel': 'Search',
  'common.errorTitle': 'Something went wrong',
  'common.errorMessage': 'An error occurred while loading the data. Please try again.',
  'common.tryAgain': 'Try Again',
  'common.selectOption': 'Select an option',
  'common.confirm': 'Confirm',
  'common.tableEmpty': 'No data available',

  // ──────────────────────────────────────────────
  // LANGUAGE SWITCHER
  // ──────────────────────────────────────────────
  'lang.switchToEn': 'Switch to English',
  'lang.switchToEs': 'Switch to Spanish',

  // ──────────────────────────────────────────────
  // NAV (GlobalSidebar)
  // ──────────────────────────────────────────────
  'nav.dashboard': 'Dashboard',
  'nav.slaDashboard': 'SLA Dashboard',
  'nav.tickets': 'Tickets',
  'nav.plants': 'Plants',
  'nav.clients': 'Clients',
  'nav.contracts': 'Contracts',
  'nav.serviceTypes': 'Service Types',
  'nav.contacts': 'Contacts',
  'nav.departments': 'Departments',
  'nav.categories': 'Categories',
  'nav.reports': 'Reports',
  'nav.auditLog': 'Audit Log',
  'nav.users': 'Users',
  'nav.notifications': 'Notifications',
  'nav.settings': 'Settings',
  'nav.newTicket': 'New Ticket',
  'nav.editProfile': 'Edit Profile',
  'nav.signOut': 'Sign Out',
  'nav.signedInAs': 'Signed in as',
  'nav.profile': 'Profile',
  'nav.signOutConfirmTitle': 'Sign Out',
  'nav.signOutConfirmMsg': 'Are you sure you want to sign out of Cysol?',

  // ──────────────────────────────────────────────
  // TOPBAR
  // ──────────────────────────────────────────────
  'topbar.searchPlaceholder': 'Search tickets, clients, plants...',
  'topbar.notifications': 'Notifications',
  'topbar.viewAllNotifications': 'View all notifications',
  'topbar.searching': 'Searching...',
  'topbar.noResultsFound': 'No results found',
  'topbar.viewAllResults': 'View all results',

  // ──────────────────────────────────────────────
  // HOME PAGE
  // ──────────────────────────────────────────────
  'home.nav.services': 'Services',
  'home.nav.about': 'About',
  'home.nav.contactUs': 'Access',
  'home.nav.adminPortal': 'Admin Portal',
  'home.toggleMenu': 'Toggle menu',
  'home.logo.tagline': 'Industrial Cleaning Solutions',
  'home.hero.badge': 'Professional Industrial Cleaning',
  'home.hero.title': 'Complete Cleaning Solutions for',
  'home.hero.titleHighlight': 'Industrial Plants',
  'home.hero.subtitle': 'Centralized complaint and service ticket management platform. Real-time visibility, SLA tracking, and seamless communication between Cysol teams and clients across Argentina.',
  'home.hero.submitTicket': 'Submit Service Ticket',
  'home.hero.accessPortal': 'Access Portal',
  'home.hero.activePlants': 'Active Plants',
  'home.hero.support': 'Support',
  'home.hero.responseTime': 'Response Time',
  'home.hero.mockTicket.type': 'Equipment Maintenance',
  'home.hero.mockTicket.status': 'In Progress',
  'home.hero.mockTicket.plant': 'Plant: San Luis - Production A',
  'home.hero.mockTicket.assigned': 'Assigned: Operations Team',
  'home.hero.mockTicket.eta': 'ETA: 4 hours remaining',
  'home.hero.mockTicket.progress': 'Progress',
  'home.services.title': 'Comprehensive Service Management',
  'home.services.subtitle': 'Our platform streamlines complaint handling, service requests, and operational communication across all your industrial facilities.',
  'home.services.ticketMgmt.title': 'Ticket Management',
  'home.services.ticketMgmt.desc': 'Create, track, and resolve service tickets with real-time status updates and automated notifications.',
  'home.services.slaTracking.title': 'SLA Tracking',
  'home.services.slaTracking.desc': 'Monitor service level agreements with automatic escalation when response times exceed thresholds.',
  'home.services.teamCollab.title': 'Team Collaboration',
  'home.services.teamCollab.desc': 'Seamless communication between operations, HR, commercial, and administration departments.',
  'home.services.dashboard.title': 'Real-Time Dashboard',
  'home.services.dashboard.desc': 'Comprehensive analytics and KPIs for complaint trends, resolution times, and team performance.',
  'home.services.auditHistory.title': 'Audit History',
  'home.services.auditHistory.desc': 'Complete timeline of all actions, comments, and status changes for full transparency and accountability.',
  'home.services.smartNotif.title': 'Smart Notifications',
  'home.services.smartNotif.desc': 'Automated alerts for ticket assignments, escalations, and resolution updates to all stakeholders.',
  'home.about.title': 'About Cysol',
  'home.about.p1': 'Cysol is a leading industrial cleaning company in Argentina, specializing in comprehensive cleaning solutions for manufacturing plants, warehouses, and industrial facilities.',
  'home.about.p2': 'Our ticket management platform was built to eliminate communication chaos, provide real-time visibility, and ensure every complaint is tracked, assigned, and resolved efficiently with full accountability.',
  'home.about.feature1.title': 'Professional Team',
  'home.about.feature1.desc': 'Experienced operations, HR, commercial, and administration departments working together.',
  'home.about.feature2.title': '24/7 Support',
  'home.about.feature2.desc': 'Round-the-clock monitoring and response for critical industrial cleaning needs.',
  'home.about.feature3.title': 'Quality Assurance',
  'home.about.feature3.desc': 'Strict SLA compliance and escalation protocols ensure timely resolution.',
  'home.about.stat.activePlants': 'Active Plants',
  'home.about.stat.ticketsResolved': 'Tickets Resolved',
  'home.about.stat.clientSatisfaction': 'Client Satisfaction',
  'home.about.stat.avgResponse': 'Avg Response',
  'home.cta.title': 'Ready to Streamline Your Service Management?',
  'home.cta.subtitle': 'Join our platform today and experience seamless complaint tracking, real-time updates, and efficient resolution workflows.',
  'home.cta.submitFirst': 'Submit Your First Ticket',
  'home.cta.accessPortal': 'Access Portal',
  'home.footer.description': 'Professional industrial cleaning solutions with comprehensive service ticket management across Argentina.',
  'home.footer.quickLinks': 'Quick Links',
  'home.footer.services': 'Services',
  'home.footer.aboutUs': 'About Us',
  'home.footer.login': 'Login',
  'home.footer.contact': 'Contact',
  'home.footer.rights': 'All rights reserved.',
  'home.footer.tagline': 'Professional Industrial Cleaning Solutions.',

  // ──────────────────────────────────────────────
  // LOGIN PAGE
  // ──────────────────────────────────────────────
  'login.welcomeBack': 'Welcome back',
  'login.subtitle': 'Sign in to access your complaint management portal',
  'login.emailAddress': 'Email address',
  'login.emailPlaceholder': 'you@company.com',
  'login.forgotEmailPlaceholder': 'your@email.com',
  'login.clientPortalLinkMissing':
    'Your account is for the client portal, but no contact is linked to this email. Ask your administrator to create a contact with the same email, then sign in from the client portal.',
  'login.password': 'Password',
  'login.rememberMe': 'Remember me',
  'login.forgotPassword': 'Forgot password?',
  'login.signIn': 'Sign in',
  'login.signingIn': 'Signing in...',
  'login.needAccess': 'Need access?',
  'login.contactAdmin': 'Contact your administrator',
  'login.feature1': 'Real-time ticket tracking',
  'login.feature1Desc': 'Monitor all complaints across 16+ industrial plants',
  'login.feature2': 'Automated escalation',
  'login.feature2Desc': 'Never miss an SLA with smart notifications',
  'login.feature3': 'Complete audit trail',
  'login.feature3Desc': 'Full history and accountability for every ticket',
  'login.errorInvalidCredentials': 'Invalid email or password. Please try again.',
  'login.passwordPlaceholder': 'Enter your password',
  'login.forgotInstructions': "Enter your email and we'll send instructions to reset your password.",
  'login.send': 'Send',
  'login.forgotSuccess': 'If an account exists with that email, you will receive reset instructions.',
  'login.brandBadge': 'Industrial services with full traceability',
  'login.brandTitle': 'Cleaning, maintenance and gardening with digital control',
  'login.brandDescription': 'Streamline your industrial cleaning operations with real-time visibility, SLA tracking, and seamless collaboration across all your plants.',

  // ──────────────────────────────────────────────
  // RESET PASSWORD
  // ──────────────────────────────────────────────
  'resetPassword.title': 'Reset password',
  'resetPassword.send': 'Send',
  'resetPassword.subtitle': 'Enter your new password below',
  'resetPassword.newPassword': 'New Password',
  'resetPassword.confirmPassword': 'Confirm Password',
  'resetPassword.placeholderNew': 'Enter new password',
  'resetPassword.placeholderConfirm': 'Confirm new password',
  'resetPassword.goLogin': 'Go to Login',
  'resetPassword.noToken': 'No reset token found. Please request a new password reset from the login page.',
  'resetPassword.submit': 'Reset Password',
  'resetPassword.submitting': 'Resetting…',
  'resetPassword.err.invalidToken': 'Invalid or missing reset token. Please request a new password reset.',
  'resetPassword.err.shortPassword': 'Password must be at least 6 characters long.',
  'resetPassword.err.mismatch': 'Passwords do not match.',
  'resetPassword.err.network': 'Network error. Please try again.',
  'resetPassword.successDefault': 'Password has been reset successfully.',
  'resetPassword.failedDefault': 'Failed to reset password. The link may have expired.',
  'resetPassword.backToLogin': '← Back to Login',

  // ──────────────────────────────────────────────
  // DASHBOARD
  // ──────────────────────────────────────────────
  'dashboard.title': 'Dashboard',
  'dashboard.subtitle': 'Overview of complaint management system',
  'dashboard.exportReport': 'Export Report',
  'dashboard.escalationAlert': 'Escalation Alert: Immediate Attention Required',
  'dashboard.escalatedTickets': 'escalated ticket(s)',
  'dashboard.overdueSlA': 'overdue SLA ticket(s)',
  'dashboard.viewAllEscalated': 'View All Escalated Tickets',
  'dashboard.thisWeek': 'This week',
  'dashboard.failedToLoad': 'Failed to load dashboard',
  'dashboard.kpi.totalComplaints': 'Total Complaints',
  'dashboard.kpi.openComplaints': 'Open Complaints',
  'dashboard.kpi.resolvedComplaints': 'Resolved Complaints',
  'dashboard.kpi.escalatedComplaints': 'Escalated Complaints',
  'dashboard.weeklyProgress': 'Weekly Progress',
  'dashboard.complaintsByCategory': 'Complaints by Category',
  'dashboard.complaintsByDept': 'Complaints by Department',
  'dashboard.topPlants': 'Top Plants by Complaints',
  'dashboard.recentActivity': 'Recent Activity',
  'dashboard.viewAllPlants': 'View all plants',
  'dashboard.loadErrorMessage': 'We couldn\'t load the dashboard data. Please check your connection and try again.',
  'dashboard.refreshingToast': 'Refreshing dashboard data...',
  'dashboard.exportSuccessToast': 'Dashboard data exported successfully!',
  'dashboard.banner.requireAction': '{{escalatedCount}} {{escalatedLabel}} and {{overdueCount}} {{overdueLabel}} require immediate action.',
  'dashboard.overdueHours': '{{hours}}h overdue',
  'dashboard.moreEscalatedTickets': '+ {{count}} more escalated ticket(s)',
  'dashboard.kpiBadge.active': 'Active',
  'dashboard.kpiBadge.completed': 'Completed',
  'dashboard.kpiBadge.urgent': 'Urgent',
  'dashboard.pendingComplaints': '{{count}} complaints still pending resolution',
  'dashboard.completionRate': 'Completion rate',
  'dashboard.activity.escalated': 'escalated ticket',
  'dashboard.activity.created': 'created ticket',
  'dashboard.activity.resolved': 'resolved ticket',
  'dashboard.activity.closed': 'closed ticket',
  'dashboard.activity.updated': 'updated ticket',
  'dashboard.export.summary': 'Dashboard Summary',
  'dashboard.export.metric': 'Metric,Value',
  'dashboard.export.totalComplaints': 'Total Complaints',
  'dashboard.export.openComplaints': 'Open Complaints',
  'dashboard.export.resolved': 'Resolved',
  'dashboard.export.escalated': 'Escalated',
  'dashboard.export.completionRate': 'Completion Rate',
  'dashboard.export.byCategory': 'By Category',
  'dashboard.export.categoryHeader': 'Category,Count,Percentage',
  'dashboard.export.byDepartment': 'By Department',
  'dashboard.export.departmentHeader': 'Department,Count,Percentage',
  'dashboard.export.recentTickets': 'Recent Tickets',
  'dashboard.export.ticketsHeader': 'ID,Title,Client,Plant,Status,Priority,Owner,Created',

  // ──────────────────────────────────────────────
  // PLANTS
  // ──────────────────────────────────────────────
  'plants.title': 'Plants Management',
  'plants.subtitle': 'Manage industrial plants and facilities across all client locations',
  'plants.addNew': 'Add New Plant',
  'plants.totalPlants': 'Total Plants',
  'plants.activePlants': 'Active Plants',
  'plants.comingSoon': 'Coming Soon',
  'plants.totalClients': 'Total Clients',
  'plants.searchPlaceholder': 'Search by name, location, or client...',
  'plants.filterStatus': 'Status',
  'plants.filterClient': 'Client',
  'plants.col.plantName': 'Plant Name',
  'plants.col.client': 'Client',
  'plants.col.location': 'Location',
  'plants.col.status': 'Status',
  'plants.col.created': 'Created',
  'plants.col.actions': 'Actions',
  'plants.loading': 'Loading plants...',
  'plants.notFound': 'No plants found matching your filters',
  'plants.modal.addTitle': 'Add New Plant',
  'plants.modal.editTitle': 'Edit Plant',
  'plants.modal.detailTitle': 'Plant Detail',
  'plants.form.plantName': 'Plant Name',
  'plants.form.client': 'Client',
  'plants.form.location': 'Location',
  'plants.form.status': 'Status',
  'plants.form.contactEmail': 'Contact Email',
  'plants.form.contactPhone': 'Contact Phone',
  'plants.form.selectClient': 'Select a client',
  'plants.form.adding': 'Adding...',
  'plants.form.addPlant': 'Add Plant',
  'plants.form.saving': 'Saving...',
  'plants.form.namePlaceholder': 'e.g., Planta Quilmes',
  'plants.form.locationPlaceholder': 'e.g., Buenos Aires',
  'plants.form.emailPlaceholder': 'email@example.com',
  'plants.form.phonePlaceholder': '+54 11 1234-5678',
  'plants.deleteTitle': 'Confirm Delete',
  'plants.tooltip.deletePlant': 'Delete plant',
  'plants.deleteConfirm': 'Are you sure you want to delete this plant? This action cannot be undone.',
  'plants.detail.plantInfo': 'Plant Information',
  'plants.detail.contactInfo': 'Contact Information',
  'plants.detail.lastUpdated': 'Last updated: {{date}}',
  'plants.noActivity': 'No activity',

  // ──────────────────────────────────────────────
  // CLIENTS
  // ──────────────────────────────────────────────
  'clients.title': 'Clients Management',
  'clients.subtitle': 'Manage client companies, contacts, and service agreements',
  'clients.totalClients': 'Total Clients',
  'clients.activeClients': 'Active Clients',
  'clients.pendingPayment': 'Pending Payment',
  'clients.withManager': 'With Manager',
  'clients.searchPlaceholder': 'Search by name, industry, or ID...',
  'clients.addClient': 'Add Client',
  'clients.col.client': 'Client',
  'clients.col.industry': 'Industry',
  'clients.col.contact': 'Contact',
  'clients.col.payment': 'Payment',
  'clients.col.accountManager': 'Account Manager',
  'clients.col.status': 'Status',
  'clients.col.actions': 'Actions',
  'clients.loading': 'Loading clients...',
  'clients.notFound': 'No clients found matching your filters',
  'clients.modal.detailTitle': 'Client Details',
  'clients.modal.addTitle': 'Add New Client',
  'clients.modal.editTitle': 'Edit Client',
  'clients.detail.email': 'Email',
  'clients.detail.phone': 'Phone',
  'clients.detail.website': 'Website',
  'clients.detail.industry': 'Industry',
  'clients.detail.status': 'Status',
  'clients.detail.paymentStatus': 'Payment Status',
  'clients.detail.accountManager': 'Account Manager',
  'clients.detail.created': 'Created',
  'clients.editClient': 'Edit Client',
  'clients.form.companyName': 'Company Name',
  'clients.form.industry': 'Industry',
  'clients.form.companyPlaceholder': 'Enter company name',
  'clients.form.industryPlaceholder': 'e.g., agroindustria',
  'clients.form.emailPlaceholder': 'email@company.com',
  'clients.form.phonePlaceholder': '+54 9 XXX XXX-XXXX',
  'clients.form.websitePlaceholder': 'https://www.company.com',
  'clients.deleteTitle': 'Confirm Delete',
  'clients.payment.current': 'Current',
  'clients.payment.pending': 'Pending',
  'clients.payment.overdue': 'Overdue',
  'clients.deleteConfirm': 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',

  // ──────────────────────────────────────────────
  // USERS
  // ──────────────────────────────────────────────
  'users.title': 'Users & Roles Management',
  'users.subtitle': 'Manage users, roles, permissions, and departments',
  'users.totalUsers': 'Total Users',
  'users.activeUsers': 'Active Users',
  'users.roles': 'Roles',
  'users.departments': 'Departments',
  'users.tab.users': 'Users',
  'users.tab.roles': 'Roles',
  'users.tab.departments': 'Departments',
  'users.searchPlaceholder': 'Search by name, email, or ID...',
  'users.allRoles': 'All Roles',
  'users.addUser': 'Add User',
  'users.col.user': 'User',
  'users.col.role': 'Role',
  'users.col.department': 'Department',
  'users.col.contact': 'Contact',
  'users.col.status': 'Status',
  'users.col.actions': 'Actions',
  'users.notFound': 'No users found matching your filters',
  'users.modal.addTitle': 'Add New User',
  'users.modal.editTitle': 'Edit User',
  'users.modal.viewTitle': 'View User',
  'users.form.fullName': 'Full Name',
  'users.form.email': 'Email',
  'users.form.phone': 'Phone',
  'users.form.password': 'Password',
  'users.form.newPassword': 'New Password',
  'users.form.role': 'Role',
  'users.form.status': 'Status',
  'users.form.selectRole': 'Select role',
  'users.form.adding': 'Adding...',
  'users.form.addUser': 'Add User',
  'users.form.saving': 'Saving...',
  'users.form.leaveBlank': 'Leave blank to keep current',
  'users.roles.manageDesc': 'Manage roles and permissions',
  'users.roles.addRole': 'Add Role',
  'users.roles.addTitle': 'Add New Role',
  'users.roles.editTitle': 'Edit Role',
  'users.roles.roleName': 'Role Name',
  'users.roles.description': 'Description',
  'users.roles.department': 'Department',
  'users.roles.roleNamePlaceholder': 'Enter role name',
  'users.roles.descPlaceholder': 'Describe the role responsibilities',
  'users.roles.selectDept': 'Select department',
  'users.roles.notFound': 'No roles found',
  'users.roles.adding': 'Adding...',
  'users.roles.addRoleBtn': 'Add Role',
  'users.roles.saving': 'Saving...',
  'users.depts.overview': 'Department overview and statistics',
  'users.depts.notFound': 'No departments found',
  'users.loadError': 'Failed to load users',
  'users.allStatus': 'All Status',
  'users.showingRange': 'Showing {{from}}–{{to}} of {{total}}',
  'users.morePermissions': '+{{count}} more',
  'users.emailPlaceholder': 'email@cysol.com.ar',
  'users.phonePlaceholder': '+54 9 XXX XXX-XXXX',
  'users.form.fullNamePlaceholder': 'Enter full name',
  'users.form.passwordPlaceholder': 'Enter password',
  'users.roles.deleteTitle': 'Delete Role',
  'users.roles.deleteConfirm':
    'Are you sure you want to delete {{name}}? This action cannot be undone.',
  'users.roles.deleting': 'Deleting...',
  'users.roles.delete': 'Delete',

  // ──────────────────────────────────────────────
  // DEPARTMENTS
  // ──────────────────────────────────────────────
  'departments.title': 'Departments',
  'departments.subtitle': 'Manage organizational departments and their assignments',
  'departments.totalDepts': 'Total Departments',
  'departments.active': 'Active',
  'departments.inactive': 'Inactive',
  'departments.thisPage': 'This Page',
  'departments.searchPlaceholder': 'Search departments...',
  'departments.addDept': 'Add Department',
  'departments.notFound': 'No departments found',
  'departments.modal.addTitle': 'Add Department',
  'departments.modal.editTitle': 'Edit Department',
  'departments.form.deptName': 'Department Name',
  'departments.form.description': 'Description',
  'departments.form.status': 'Status',
  'departments.form.deptNamePlaceholder': 'e.g., Quality Assurance',
  'departments.form.descPlaceholder': 'Brief description of the department',
  'departments.form.adding': 'Adding...',
  'departments.form.addDept': 'Add Department',
  'departments.form.saving': 'Saving...',
  'departments.loadError': 'Failed to load departments',
  'departments.deleteTitle': 'Delete Department',
  'departments.deleteConfirm':
    'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
  'departments.createdOn': 'Created: {{date}}',
  'departments.form.deleting': 'Deleting...',

  // ──────────────────────────────────────────────
  // CONTACTS
  // ──────────────────────────────────────────────
  'contacts.title': 'Authorized Contacts',
  'contacts.subtitle': 'Manage client contacts authorized to submit tickets',
  'contacts.totalContacts': 'Total Contacts',
  'contacts.activeContacts': 'Active Contacts',
  'contacts.clientsCovered': 'Clients Covered',
  'contacts.plantAuthorizations': 'Plant Authorizations',
  'contacts.searchPlaceholder': 'Search by name, email or client...',
  'contacts.addContact': 'Add Contact',
  'contacts.col.contact': 'Contact',
  'contacts.col.client': 'Client',
  'contacts.col.phone': 'Phone',
  'contacts.col.plants': 'Plants',
  'contacts.col.created': 'Created',
  'contacts.col.status': 'Status',
  'contacts.col.actions': 'Actions',
  'contacts.notFound': 'No contacts found',
  'contacts.modal.addTitle': 'Add Contact',
  'contacts.modal.editTitle': 'Edit Contact',
  'contacts.form.fullName': 'Full Name',
  'contacts.form.email': 'Email',
  'contacts.form.phone': 'Phone',
  'contacts.form.password': 'Password (portal access)',
  'contacts.form.passwordOptional': 'Password (optional)',
  'contacts.form.canCreateTickets': 'Can Create Tickets',
  'contacts.form.client': 'Client',
  'contacts.form.selectClient': 'Select client',
  'contacts.form.authorizedPlants': 'Authorized Plants',
  'contacts.form.noPlantsForClient': 'No plants found for this client',
  'contacts.form.saving': 'Saving...',
  'contacts.form.addContact': 'Add Contact',
  'contacts.form.saveChanges': 'Save Changes',
  'contacts.delete.title': 'Delete Contact',
  'contacts.delete.confirm': 'Are you sure you want to delete',
  'contacts.form.namePlaceholder': 'John Doe',
  'contacts.form.emailPlaceholder': 'john@company.com',
  'contacts.form.phonePlaceholder': '+1 555 000 0000',
  'contacts.form.passwordPlaceholderAdd': 'Set password to enable client portal login',
  'contacts.form.passwordPlaceholderEdit': 'Leave blank to keep current • Enter new password to change',
  'contacts.form.passwordHelpAdd': 'The contact will use this password to log in to the client portal.',
  'contacts.form.passwordHelpEdit': 'Only fill to set or change the password for portal access.',
  'contacts.form.status': 'Status',
  'contacts.form.position': 'Position',
  'contacts.form.selectPosition': 'Select position',
  'contacts.col.position': 'Position',
  'contacts.delete.confirmFull':
    'Are you sure you want to delete {{name}} ({{client}})? This action cannot be undone.',
  'contacts.showingRange': 'Showing {{from}}–{{to}} of {{total}} contacts',
  'contacts.includeDeleted': 'Include deleted',
  'contacts.deletedBadge': 'Deleted',
  'contacts.restore': 'Restore',
  'contacts.restoreError': 'Could not restore the contact',

  // ──────────────────────────────────────────────
  // CONTRACTS
  // ──────────────────────────────────────────────
  'contracts.title': 'Contracts & Services',
  'contracts.subtitle': 'Manage client contracts and service agreements',
  'contracts.totalContracts': 'Total Contracts',
  'contracts.active': 'Active',
  'contracts.upForRenewal': 'Up for Renewal',
  'contracts.pending': 'Pending',
  'contracts.activeArr': 'Active ARR',
  'contracts.searchPlaceholder': 'Search contracts, clients, IDs…',
  'contracts.allServiceTypes': 'All Service Types',
  'contracts.newContract': 'New Contract',
  'contracts.loading': 'Loading contracts...',
  'contracts.notFound': 'No contracts found',
  'contracts.col.contract': 'Contract',
  'contracts.col.client': 'Client',
  'contracts.col.type': 'Type',
  'contracts.col.value': 'Value',
  'contracts.col.period': 'Period',
  'contracts.col.status': 'Status',
  'contracts.col.renewal': 'Renewal',
  'contracts.col.actions': 'Actions',
  'contracts.showing': 'Showing',
  'contracts.ofContracts': 'contracts',
  'contracts.modal.newTitle': 'New Contract',
  'contracts.modal.editTitle': 'Edit Contract',
  'contracts.detail.client': 'Client',
  'contracts.detail.accountManager': 'Account Manager',
  'contracts.detail.contractValue': 'Contract Value',
  'contracts.detail.payment': 'Payment',
  'contracts.detail.startDate': 'Start Date',
  'contracts.detail.endDate': 'End Date',
  'contracts.detail.renewalDate': 'Renewal Date',
  'contracts.detail.signed': 'Signed',
  'contracts.detail.plantsCovered': 'Plants Covered',
  'contracts.detail.servicesIncluded': 'Services Included',
  'contracts.detail.monthlyTotal': 'Monthly total:',
  'contracts.detail.notes': 'Notes',
  'contracts.detail.documents': 'Documents',
  'contracts.detail.editContract': 'Edit Contract',
  'contracts.selectClient': 'Select client…',
  'contracts.searchClient': 'Search client…',
  'contracts.plant': 'plant',
  'contracts.plants': 'plants',
  'contracts.view': 'View',
  'contracts.loadingClients': 'Loading clients…',
  'contracts.selectAccountManager': 'Select account manager…',
  'contracts.attachHint': 'Attach documents to the contract. They will be uploaded after creation.',
  'contracts.selectFilesAttach': 'Select files to attach',
  'contracts.form.titlePlaceholder': 'e.g. Industrial Cleaning Services — Plant X',
  'contracts.form.notesPlaceholder': 'Special requirements, SLA notes…',
  'contracts.tooltip.download': 'Download',
  'contracts.tooltip.remove': 'Remove',
  'contracts.filter.allClients': 'All Clients',
  'contracts.filter.allStatus': 'All Status',
  'contracts.showingCount': 'Showing {{count}} of {{total}} contracts',
  'contracts.card.periodStart': 'Start',
  'contracts.card.periodEnd': 'End',
  'contracts.documentsLoading': 'Loading…',
  'contracts.retry': 'Retry',
  'contracts.form.contractTitle': 'Contract Title',
  'contracts.form.serviceType': 'Service Type',
  'contracts.form.selectService': 'Select…',
  'contracts.form.startDate': 'Start Date',
  'contracts.form.endDate': 'End Date',
  'contracts.form.renewalDate': 'Renewal Date',
  'contracts.form.valueUsd': 'Contract Value ($)',
  'contracts.form.paymentFrequency': 'Payment Frequency',
  'contracts.freq.monthly': 'Monthly',
  'contracts.freq.quarterly': 'Quarterly',
  'contracts.freq.annual': 'Annual',
  'contracts.status.expired': 'Expired',
  'contracts.status.terminated': 'Terminated',
  'contracts.err.load': 'Error loading contracts',
  'contracts.err.loadDropdowns': 'Error loading data',
  'contracts.err.create': 'Error creating contract',
  'contracts.err.update': 'Error updating contract',
  'contracts.err.delete': 'Error deleting contract',
  'contracts.err.uploadAfterCreate': 'Contract created but failed to upload: {{fileName}}',
  'contracts.plantHash': 'Plant #{{id}}',
  'contracts.renewalOverdue': '{{days}}d overdue',
  'contracts.renewalCountdown': '{{days}}d to renewal',
  'contracts.clientHash': 'Client #{{id}}',
  'contracts.noClientsSearch': 'No clients match your search',
  'contracts.noClientsHint': 'No clients found. Create clients first in the Clients section.',
  'contracts.form.documentsOptional': 'Documents (optional)',
  'contracts.createContract': 'Create Contract',
  'contracts.delete.title': 'Delete Contract',
  'contracts.delete.confirm':
    'Are you sure you want to delete "{{title}}"? This action cannot be undone.',

  // ──────────────────────────────────────────────
  // CATEGORIES
  // ──────────────────────────────────────────────
  'categories.title': 'Ticket Categories',
  'categories.subtitle': 'Manage ticket categories and their department assignments',
  'categories.totalCategories': 'Total Categories',
  'categories.active': 'Active',
  'categories.inactive': 'Inactive',
  'categories.departments': 'Departments',
  'categories.searchPlaceholder': 'Search categories...',
  'categories.addCategory': 'Add Category',
  'categories.col.category': 'Category',
  'categories.col.department': 'Department',
  'categories.col.created': 'Created',
  'categories.col.status': 'Status',
  'categories.col.actions': 'Actions',
  'categories.notFound': 'No categories found',
  'categories.showing': 'Showing',
  'categories.ofCategories': 'categories',
  'categories.modal.addTitle': 'Add Category',
  'categories.modal.editTitle': 'Edit Category',
  'categories.form.categoryName': 'Category Name',
  'categories.form.description': 'Description',
  'categories.form.department': 'Department',
  'categories.form.color': 'Color',
  'categories.form.icon': 'Icon',
  'categories.form.preview': 'Preview',
  'categories.form.status': 'Status',
  'categories.form.selectDept': 'Select department',
  'categories.form.saving': 'Saving...',
  'categories.form.saving2': 'Saving...',
  'categories.form.addCategory': 'Add Category',
  'categories.form.namePlaceholder': 'e.g., Safety Incident',
  'categories.form.descPlaceholder': 'Brief description of this category',
  'categories.form.previewFallback': 'Category name',
  'categories.showingRange': 'Showing {{from}}–{{to}} of {{total}} categories',
  'categories.err.load': 'Failed to load categories',
  'categories.err.create': 'Failed to create category',
  'categories.err.update': 'Failed to update category',
  'categories.err.delete': 'Failed to delete category',
  'categories.err.toggleStatus': 'Failed to change category status',
  'categories.delete.title': 'Delete Category',
  'categories.delete.confirm':
    'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
  'categories.form.deleting': 'Deleting...',
  'categories.icon.document': 'Document',
  'categories.icon.user': 'User',
  'categories.icon.tools': 'Tools',
  'categories.icon.chat': 'Chat',
  'categories.icon.briefcase': 'Briefcase',
  'categories.icon.alert': 'Alert',
  'categories.icon.settings': 'Settings',
  'categories.icon.more': 'More',

  // ──────────────────────────────────────────────
  // AUDIT LOG
  // ──────────────────────────────────────────────
  'audit.title': 'Audit Log',
  'audit.subtitle': 'Complete traceability of all system actions and events',
  'audit.exportCsv': 'Export CSV',
  'audit.totalEvents': 'Total Events',
  'audit.criticalEvents': 'Critical Events',
  'audit.warnings': 'Warnings',
  'audit.systemActions': 'System Actions',
  'audit.searchPlaceholder': 'Search events, users, entities…',
  'audit.allModules': 'All Modules',
  'audit.allSeverities': 'All Severity',
  'audit.allUsers': 'All Users',
  'audit.col.timestamp': 'Timestamp',
  'audit.col.user': 'User',
  'audit.col.action': 'Action',
  'audit.col.module': 'Module',
  'audit.col.entity': 'Entity',
  'audit.col.ip': 'IP',
  'audit.col.severity': 'Severity',
  'audit.loading': 'Loading events…',
  'audit.notFound': 'No events found',
  'audit.showing': 'Showing',
  'audit.ofEvents': 'events',
  'audit.clickToExpand': 'Click a row to expand details',
  'audit.severity.info': 'Info',
  'audit.severity.warning': 'Warning',
  'audit.severity.critical': 'Critical',
  'audit.detailsLabel': 'Details:',
  'audit.showingOfTotal': 'Showing {{shown}} of {{total}} events',
  'audit.loadError': 'Could not load audit events',

  // ──────────────────────────────────────────────
  // SLA DASHBOARD
  // ──────────────────────────────────────────────
  'sla.title': 'SLA Dashboard',
  'sla.loading': 'Loading SLA data…',
  'sla.loadError': 'Error loading SLA data',
  'sla.subtitle': 'Real-time SLA compliance monitoring and proactive breach management',
  'sla.liveIndicator': 'Live · Last updated just now',
  'sla.overallCompliance': 'Overall Compliance',
  'sla.ticketsAtRisk': 'Tickets At Risk',
  'sla.overdueTickets': 'Overdue Tickets',
  'sla.totalTracked': 'Total Tracked',
  'sla.target': 'Target: 85%',
  'sla.approachingLimit': 'Approaching SLA limit',
  'sla.breachExceeded': 'SLA breach exceeded',
  'sla.onTrack': 'On track:',
  'sla.overallSlaCompliance': 'Overall SLA Compliance',
  'sla.resolvedOnTime': 'Resolved on time',
  'sla.breachedSla': 'Breached SLA',
  'sla.complianceByCategory': 'Compliance by Category',
  'sla.complianceByPriority': 'Compliance by Priority',
  'sla.ticketsRequiringAttention': 'Tickets Requiring Attention',
  'sla.onTrackCount': 'on track',
  'sla.tab.summary': 'Summary',
  'sla.tab.byCategory': 'By Category',
  'sla.tab.byCategoryDept': 'By Category (Department view)',
  'sla.tab.byPriority': 'By Priority',
  'sla.col.category': 'Category',
  'sla.col.totalTickets': 'Total Tickets',
  'sla.col.onTime': 'On Time',
  'sla.col.overdue': 'Overdue',
  'sla.col.compliance': 'Compliance',
  'sla.col.atRisk': 'At Risk',
  'sla.col.priority': 'Priority',
  'sla.col.slaTarget': 'SLA Target',
  'sla.col.total': 'Total',
  'sla.col.complianceVsTarget': 'Compliance vs Target',
  'sla.hoursOverdue': 'h overdue',
  'sla.hoursRemaining': 'h remaining',
  'sla.lineHoursOverdue': '{{hours}}h overdue',
  'sla.lineHoursRemaining': '{{hours}}h remaining',
  'sla.overviewOnTime': '{{onTrack}}/{{total}} on time',
  'sla.targetLine85': 'Target 85%',
  'sla.slaHours': 'SLA:',

  // ──────────────────────────────────────────────
  // NOTIFICATIONS
  // ──────────────────────────────────────────────
  'notifications.title': 'Notifications',
  'notifications.subtitle': 'Stay updated with ticket activities and system alerts',
  'notifications.markAllRead': 'Mark all as read',
  'notifications.total': 'Total',
  'notifications.unread': 'Unread',
  'notifications.ticketAlerts': 'Ticket Alerts',
  'notifications.slaWarnings': 'SLA Warnings',
  'notifications.allTypes': 'All Types',
  'notifications.assigned': 'Assigned',
  'notifications.escalated': 'Escalated',
  'notifications.comments': 'Comments',
  'notifications.resolved': 'Resolved',
  'notifications.created': 'Created',
  'notifications.slaWarning': 'SLA Warning',
  'notifications.reassigned': 'Reassigned',
  'notifications.system': 'System',
  'notifications.updated': 'Updated',
  'notifications.allStatus': 'All Status',
  'notifications.showingOf': 'Showing {{count}} of {{total}} notifications',
  'notifications.loading': 'Loading notifications...',
  'notifications.loadError': 'Failed to load notifications',
  'notifications.markAsReadTitle': 'Mark as read',
  'notifications.detailsMoreFields': '+{{count}} more',
  'notifications.eventType.ticket_assigned': 'Ticket Assigned',
  'notifications.eventType.ticket_escalated': 'Ticket Escalated',
  'notifications.eventType.ticket_comment': 'New Comment',
  'notifications.eventType.ticket_resolved': 'Ticket Resolved',
  'notifications.eventType.ticket_created': 'Ticket Created',
  'notifications.eventType.sla_warning': 'SLA Warning',
  'notifications.eventType.ticket_reassigned': 'Ticket Reassigned',
  'notifications.eventType.ticket_updated': 'Ticket Updated',
  'notifications.eventType.system': 'System',
  'notifications.eventFallback': 'Notification',
  'notifications.ticketNumber': 'Ticket #{{id}}',
  'notifications.notFound': 'No notifications found',
  'notifications.allCaughtUp': 'You\'re all caught up! No unread notifications.',
  'notifications.adjustFilters': 'Try adjusting your filters to see more notifications.',
  'notifications.modal.dateTime': 'Date & Time',
  'notifications.modal.status': 'Status',
  'notifications.modal.priority': 'Priority',
  'notifications.modal.relatedTicket': 'Related Ticket',
  'notifications.modal.viewTicket': 'View Ticket',

  // ──────────────────────────────────────────────
  // SETTINGS
  // ──────────────────────────────────────────────
  'settings.title': 'Settings & Configuration',
  'settings.subtitle':
    'Manage SLA rules, escalation policies, notification preferences, role permissions (administration), and system enumerables',
  'settings.tab.general': 'General',
  'settings.tab.sla': 'SLA Rules',
  'settings.tab.escalation': 'Escalation Rules',
  'settings.tab.notifications': 'Notification Preferences',
  'settings.tab.rolePerms': 'Role permissions',
  'settings.tab.enums': 'Enumerables',
  'settings.rolePerms.title': 'Role permissions',
  'settings.rolePerms.subtitle':
    'Pick a role and check or uncheck permissions. Changes apply to every user with that role. If you edit your own role, the session refreshes on save.',
  'settings.rolePerms.loading': 'Loading roles and permissions…',
  'settings.rolePerms.loadFailed': 'Failed to load data',
  'settings.rolePerms.selectRole': 'Role to edit',
  'settings.rolePerms.chooseRole': 'Select a role…',
  'settings.rolePerms.selectAll': 'Select all',
  'settings.rolePerms.clearAll': 'Clear all',
  'settings.rolePerms.groupSelect': 'Group: select',
  'settings.rolePerms.groupClear': 'Group: clear',
  'settings.rolePerms.discard': 'Discard changes',
  'settings.rolePerms.warning':
    'A role without the “Manage users” permission will not be able to open this screen again. Do not remove that permission from your own role without another way to administer the system.',
  'settings.rolePerms.save': 'Save permissions',
  'settings.rolePerms.saving': 'Saving…',
  'settings.rolePerms.saved': 'Role permissions updated',
  'settings.rolePerms.saveFailed': 'Could not save permissions',
  'settings.rolePerms.reload': 'Reload list',
  'settings.rolePerms.loadingRole': 'Loading role permissions…',
  'settings.rolePerms.orphanTitle': 'Permissions not shown above',
  'settings.rolePerms.orphanSubtitle':
    'These are stored on the role but are missing from the active catalog (for example, a permission marked inactive in enumerables). Remove them here or keep them until the catalog is aligned.',
  'settings.rolePerms.orphanRemoveAll': 'Remove all unlisted',
  'settings.rolePerms.groupOther': 'Other',
  'settings.rolePerms.groups.tickets': 'Tickets',
  'settings.rolePerms.groups.reports': 'Reports',
  'settings.rolePerms.groups.admin': 'Administration',
  'settings.rolePerms.keys.view_all_tickets': 'View all tickets',
  'settings.rolePerms.keys.view_assigned_tickets': 'View assigned tickets',
  'settings.rolePerms.keys.view_client_tickets': 'View client tickets',
  'settings.rolePerms.keys.view_own_tickets': 'View own tickets',
  'settings.rolePerms.keys.create_ticket': 'Create ticket',
  'settings.rolePerms.keys.edit_ticket': 'Edit ticket',
  'settings.rolePerms.keys.assign_ticket': 'Assign ticket',
  'settings.rolePerms.keys.escalate_ticket': 'Escalate ticket',
  'settings.rolePerms.keys.resolve_ticket': 'Resolve ticket',
  'settings.rolePerms.keys.comment_ticket': 'Comment on ticket',
  'settings.rolePerms.keys.view_reports': 'View reports',
  'settings.rolePerms.keys.manage_users': 'Manage users and roles',
  'settings.rolePerms.keys.manage_plants': 'Manage plants',
  'settings.rolePerms.keys.manage_clients': 'Manage clients',
  'settings.rolePerms.keys.manage_contracts': 'Manage contracts',
  'settings.rolePerms.keys.configure_sla': 'Configure SLA rules',
  'settings.rolePerms.keys.view_audit_log': 'View audit log',
  'settings.rolePerms.keys.manage_enums': 'Manage enumerables',
  'settings.rolePerms.keys.delete_core_entities': 'Delete clients, contracts, plants, etc.',
  'settings.rolePerms.keys.delete_ticket': 'Delete tickets and attachments',
  'settings.rolePerms.keys.delete_reference_data': 'Delete reference data (categories, departments, etc.)',
  'settings.general.title': 'General Settings',
  'settings.general.subtitle': 'System-wide configuration',
  'settings.general.timezone': 'Timezone',
  'settings.general.timezoneDesc': 'All dates and times displayed in the system will be converted to this timezone',
  'settings.general.timezonePlaceholder': 'Search timezone…',
  'settings.general.currentTime': 'Current time in selected timezone',
  'settings.general.save': 'Save',
  'settings.general.saving': 'Saving…',
  'settings.general.saved': 'Settings saved successfully',
  'settings.general.saveFailed': 'Failed to save settings',
  'settings.sla.title': 'SLA Rules by Category & Priority',
  'settings.sla.subtitle': 'Define response and resolution times for each ticket type',
  'settings.sla.addRule': 'Add SLA Rule',
  'settings.sla.loading': 'Loading SLA rules...',
  'settings.sla.col.category': 'Category',
  'settings.sla.col.priority': 'Priority',
  'settings.sla.col.responseTime': 'Response Time',
  'settings.sla.col.resolutionTime': 'Resolution Time',
  'settings.sla.col.escalation': 'Escalation',
  'settings.sla.col.department': 'Department',
  'settings.sla.col.autoAssign': 'Auto-Assign',
  'settings.sla.col.actions': 'Actions',
  'settings.sla.modal.addTitle': 'Add SLA Rule',
  'settings.sla.modal.editTitle': 'Edit SLA Rule',
  'settings.sla.form.categoryId': 'Category ID',
  'settings.sla.form.priority': 'Priority',
  'settings.sla.form.responseTime': 'Response Time (hours)',
  'settings.sla.form.resolutionTime': 'Resolution Time (hours)',
  'settings.sla.form.escalationThreshold': 'Escalation Threshold (hours)',
  'settings.sla.form.departmentId': 'Department ID',
  'settings.sla.form.autoAssign': 'Enable auto-assignment',
  'settings.sla.form.selectPriority': 'Select priority',
  'settings.sla.form.saving': 'Saving...',
  'settings.sla.form.addRule': 'Add SLA Rule',
  'settings.sla.form.saveChanges': 'Save Changes',
  'settings.escalation.title': 'Escalation Rules',
  'settings.escalation.subtitle': 'Automatic escalation triggers and actions',
  'settings.escalation.addRule': 'Add Escalation Rule',
  'settings.escalation.loading': 'Loading escalation rules...',
  'settings.escalation.trigger': 'Trigger',
  'settings.escalation.status': 'Status Transition',
  'settings.escalation.department': 'Department',
  'settings.escalation.triggerDesc': 'After {hours} hours without response',
  'settings.escalation.allDepts': 'All departments',
  'settings.escalation.modal.addTitle': 'Add Escalation Rule',
  'settings.escalation.modal.editTitle': 'Edit Escalation Rule',
  'settings.escalation.form.ruleName': 'Rule Name',
  'settings.escalation.form.triggerHours': 'Trigger Hours',
  'settings.escalation.form.fromStatus': 'From Status',
  'settings.escalation.form.toStatus': 'To Status',
  'settings.escalation.form.status': 'Status',
  'settings.escalation.form.saving': 'Saving...',
  'settings.escalation.form.addRule': 'Add Rule',
  'settings.escalation.form.saveChanges': 'Save Changes',
  'settings.notifications.title': 'Notification Preferences',
  'settings.notifications.subtitle': 'Configure how you receive notifications',
  'settings.notifications.email': 'Email Notifications',
  'settings.notifications.emailDesc': 'Receive updates via email',
  'settings.notifications.inApp': 'In-App Notifications',
  'settings.notifications.inAppDesc': 'Receive updates within the platform',
  'settings.notifications.sms': 'SMS Notifications',
  'settings.notifications.smsDesc': 'Receive critical alerts via SMS',
  'settings.notifications.savePrefs': 'Save Preferences',
  'settings.notifications.saving': 'Saving...',
  'settings.notifications.saved': 'Preferences saved successfully',
  'settings.notifications.saveFailed': 'Failed to save preferences',
  'settings.notifications.pref.ticketAssigned': 'Ticket assigned',
  'settings.notifications.pref.ticketEscalated': 'Ticket escalated',
  'settings.notifications.pref.ticketResolved': 'Ticket resolved',
  'settings.notifications.pref.ticketComment': 'Ticket comment',
  'settings.notifications.pref.slaWarning': 'SLA warning',
  'settings.notifications.pref.dailyDigest': 'Daily digest',
  'settings.notifications.pref.ticketCreated': 'Ticket created',
  'settings.notifications.pref.criticalEscalation': 'Critical escalation',
  'settings.notifications.pref.afterHoursEmergency': 'After-hours emergency',
  'settings.sla.allCategories': 'All',
  'settings.sla.form.optional': 'Optional',
  'settings.sla.form.placeholderResponse': 'e.g., 2',
  'settings.sla.form.placeholderResolution': 'e.g., 24',
  'settings.sla.form.placeholderEscalation': 'e.g., 18',
  'settings.escalation.ruleActive': 'Active',
  'settings.escalation.ruleInactive': 'Inactive',
  'settings.escalation.statusAny': 'Any',
  'settings.escalation.triggerLine': 'After {{hours}} hours without response',
  'settings.escalation.form.enterRuleName': 'Enter rule name',
  'settings.escalation.form.placeholderHours': 'e.g., 4',
  'settings.escalation.form.fromPlaceholder': 'e.g., new (optional)',
  'settings.escalation.form.toPlaceholder': 'e.g., escalated (optional)',
  'settings.enums.permissionDenied':
    'You do not have permission to add, edit, or delete enumerables. Contact your administrator to request the "Manage enumerables" permission.',
  'settings.enums.searchPlaceholder': 'Search key or label…',
  'settings.enums.recordCount': '{{filtered}} of {{total}} records',
  'settings.enums.addValue': 'Add Value',
  'settings.enums.noRecords': 'No records found',
  'settings.enums.col.badge': 'Badge',
  'settings.enums.col.key': 'Key',
  'settings.enums.col.group': 'Group',
  'settings.enums.col.order': 'Order',
  'settings.enums.col.status': 'Status',
  'settings.enums.col.type': 'Type',
  'settings.enums.col.actions': 'Actions',
  'settings.enums.groupOther': 'Other',
  'settings.enums.form.label': 'Label',
  'settings.enums.form.keySlug': 'Key (slug)',
  'settings.enums.form.placeholderLabel': 'e.g. In Progress',
  'settings.enums.form.placeholderKey': 'e.g. in_progress',
  'settings.enums.form.color': 'Colour',
  'settings.enums.form.sortOrder': 'Sort order',
  'settings.enums.form.group': 'Group',
  'settings.enums.form.groupPlaceholder': 'e.g. Tickets, Admin, Reports',
  'settings.enums.form.icon': 'Icon',
  'settings.enums.preview': 'Preview:',
  'settings.enums.previewLabelFallback': 'Label',
  'settings.enums.previewKeyFallback': 'key',
  'settings.enums.modal.newTitle': 'New Value — {{name}}',
  'settings.enums.modal.editTitle': 'Edit Value — {{name}}',
  'settings.enums.saveChanges': 'Save Changes',
  'settings.enums.deleteTitle': 'Delete value',
  'settings.enums.deleteConfirm':
    'Remove {{label}} from {{table}}? Existing records that reference this key may break.',
  'settings.enums.deleting': 'Deleting...',
  'settings.enums.deleteBtn': 'Delete',
  'settings.enums.loading': 'Loading records...',
  'settings.enums.rowActive': 'Active',
  'settings.enums.rowInactive': 'Inactive',
  'settings.enums.typeSystem': 'System',
  'settings.enums.typeCustom': 'Custom',
  'settings.enums.tables.priority.name': 'Priority',
  'settings.enums.tables.priority.desc': 'Ticket and notification priority levels',
  'settings.enums.tables.ticket_status.name': 'Ticket Status',
  'settings.enums.tables.ticket_status.desc': 'Lifecycle states a ticket can be in',
  'settings.enums.tables.sla_status.name': 'SLA Status',
  'settings.enums.tables.sla_status.desc': 'Derived SLA health status shown on ticket cards',
  'settings.enums.tables.contract_status.name': 'Contract Status',
  'settings.enums.tables.contract_status.desc': 'Lifecycle states of a client contract',
  'settings.enums.tables.payment_frequency.name': 'Payment Frequency',
  'settings.enums.tables.payment_frequency.desc': 'Billing cycle options for contracts',
  'settings.enums.tables.payment_status.name': 'Payment Status',
  'settings.enums.tables.payment_status.desc': 'Current payment standing of a contract or client',
  'settings.enums.tables.audit_severity.name': 'Audit Severity',
  'settings.enums.tables.audit_severity.desc': 'Severity levels for audit log entries',
  'settings.enums.tables.notification_type.name': 'Notification Type',
  'settings.enums.tables.notification_type.desc': 'Events that trigger a notification',
  'settings.enums.tables.timeline_event_type.name': 'Timeline Event Type',
  'settings.enums.tables.timeline_event_type.desc': "Types of events that appear in a ticket's history",
  'settings.enums.tables.notification_channel.name': 'Notification Channel',
  'settings.enums.tables.notification_channel.desc': 'Delivery channels for notifications',
  'settings.enums.tables.record_status.name': 'Record Status',
  'settings.enums.tables.record_status.desc':
    'Generic active/inactive status shared by departments, roles, contacts, etc.',
  'settings.enums.tables.client_status.name': 'Client Status',
  'settings.enums.tables.client_status.desc': 'Operational status of a client account',
  'settings.enums.tables.plant_status.name': 'Plant Status',
  'settings.enums.tables.plant_status.desc': 'Operational status of a plant',
  'settings.enums.tables.service_frequency.name': 'Service Frequency',
  'settings.enums.tables.service_frequency.desc': 'How often a service is delivered at a plant',
  'settings.enums.tables.contract_type.name': 'Contract Type',
  'settings.enums.tables.contract_type.desc': 'Coverage level assigned to a plant under a contract',
  'settings.enums.tables.industry.name': 'Industry',
  'settings.enums.tables.industry.desc': 'Business sector of a client company',
  'settings.enums.tables.permission.name': 'Permission',
  'settings.enums.tables.permission.desc': 'Granular actions that can be assigned to roles',
  'settings.enums.color.gray': 'Gray',
  'settings.enums.color.red': 'Red',
  'settings.enums.color.orange': 'Orange',
  'settings.enums.color.yellow': 'Yellow',
  'settings.enums.color.green': 'Green',
  'settings.enums.color.teal': 'Teal',
  'settings.enums.color.blue': 'Blue',
  'settings.enums.color.purple': 'Purple',
  'settings.enums.color.pink': 'Pink',

  'sla.health.on_track': 'On Track',
  'sla.health.at_risk': 'At Risk',
  'sla.health.overdue': 'Overdue',

  // ──────────────────────────────────────────────
  // SHARED: PRIORITIES & STATUSES
  // ──────────────────────────────────────────────
  'priority.low': 'Low',
  'priority.medium': 'Medium',
  'priority.high': 'High',
  'priority.critical': 'Critical',
  'priority.low.time': '3 days',
  'priority.medium.time': '2 days',
  'priority.high.time': '1 day',
  'priority.critical.time': '8 hours',
  'status.new': 'New',
  'status.in_progress': 'In Progress',
  'status.waiting': 'Waiting',
  'status.escalated': 'Escalated',
  'status.resolved': 'Resolved',
  'status.closed': 'Closed',
  'status.client_confirmed': 'Client Confirmed',
  'status.reopened': 'Reopened',

  // ──────────────────────────────────────────────
  // PORTAL REVIEW
  // ──────────────────────────────────────────────
  'portalReview.title': 'Ticket Review',
  'portalReview.loading': 'Loading ticket...',
  'portalReview.notAvailable': 'This ticket is not available for review.',
  'portalReview.notAvailableDesc': 'The link may have expired or the ticket is already resolved.',
  'portalReview.alreadyConfirmed': 'Thank you! You have already confirmed this ticket as resolved.',
  'portalReview.alreadyReopened': 'Your ticket has already been reopened. Our team will be in touch.',
  'portalReview.closed.heading': 'Your ticket has been closed',
  'portalReview.closed.subheading': 'Please let us know if the issue was resolved to your satisfaction.',
  'portalReview.ticket': 'Ticket',
  'portalReview.confirm.heading': 'Confirm Resolution',
  'portalReview.confirm.description': 'If the issue has been fully resolved, click below to confirm.',
  'portalReview.confirm.button': 'Yes, Confirm Resolution',
  'portalReview.confirm.loading': 'Confirming...',
  'portalReview.confirm.success': 'Thank you! Your confirmation has been recorded.',
  'portalReview.reopen.heading': 'Reopen Ticket',
  'portalReview.reopen.description': 'If the issue is not fully resolved, you can reopen this ticket.',
  'portalReview.reopen.commentLabel': 'What is still unresolved?',
  'portalReview.reopen.commentPlaceholder': 'Describe what still needs attention...',
  'portalReview.reopen.button': 'Reopen Ticket',
  'portalReview.reopen.loading': 'Reopening...',
  'portalReview.reopen.success': 'Your ticket has been reopened. Our team will be in touch shortly.',
  'portalReview.error': 'Something went wrong. Please try again.',

  // ──────────────────────────────────────────────
  // SHARED: VALIDATION
  // ──────────────────────────────────────────────
  'validation.nameRequired': 'Name is required',
  'validation.plantRequired': 'At least one plant must be selected',
  'validation.categoryRequired': 'Category is required',
  'validation.subjectRequired': 'Subject is required',
  'validation.descriptionRequired': 'Description is required',
  'validation.priorityRequired': 'Priority is required',
  'validation.clientRequired': 'Client is required',
  'validation.confirmRequired': 'You must confirm the information is accurate',
  'validation.selectPlant': 'Please select a plant',

  // ──────────────────────────────────────────────
  // PUBLIC TICKET / PORTAL
  // ──────────────────────────────────────────────
  'portal.title': 'Submit a Ticket',
  'portal.subtitle': 'Fill out the form to submit your request',
  'portal.description': 'Submit a new ticket, track an existing one, or sign in to view your full history',
  'portal.tabs.submit': 'Submit a Ticket',
  'portal.tabs.submitShort': 'Submit',
  'portal.tabs.track': 'Track My Ticket',
  'portal.tabs.trackShort': 'Track',
  'portal.tabs.portal': 'My Portal',
  'portal.tabs.portalShort': 'Portal',
  'portal.openTicketsTooltip': 'Your open tickets (created with your user): {{count}}',

  // Quick Lookup
  'portal.quickLookup.title': 'Quick Ticket Lookup',
  'portal.quickLookup.subtitle': 'Check any ticket status instantly — no login required',
  'portal.quickLookup.placeholder': 'e.g.: TK-001',
  'portal.quickLookup.search': 'Search',
  'portal.quickLookup.searching': 'Searching...',
  'portal.quickLookup.notFound': 'No ticket "{{id}}". Check the format TK-001.',
  'portal.quickLookup.searchAnother': 'Search another ticket',
  'portal.quickLookup.resolvedOn': 'Resolved on {{date}}',

  // Contact Verification
  'portal.verify.title': 'Contact Verification',
  'portal.verify.description': 'Only authorized contacts can create tickets. Enter your registered email to continue. No password needed for submission. For full portal access (profile, ticket history), use <strong>My Portal</strong> with your password.',
  'portal.verify.emailLabel': 'Email Address',
  'portal.verify.placeholder': 'your.email@company.com',
  'portal.verify.verifying': 'Verifying...',
  'portal.verify.verifyBtn': 'Verify & Continue',
  'portal.verify.emailNotFound': 'Email not found',
  'portal.verify.emailNotFoundDesc': 'No authorized contact found for this email. Please try again or contact your Cysol account representative.',
  'portal.verify.authError': 'Authentication Error',
  'portal.verify.authErrorDefault': 'We could not validate your credentials at the moment. Please try again later.',
  'portal.verify.authForbidden': 'Your account is not authorized for ticket submission. Contact your Cysol representative.',

  // Common
  'common.back': 'Back',

  // Verified Banner
  'portal.verified.title': 'Authorized Contact Verified',
  'portal.verified.welcome': 'Welcome, {{name}}. You can now submit a service ticket.',

  // Submit Form
  'portal.form.reporterInfo': 'Reporter Information',
  'portal.form.yourName': 'Your Name',
  'portal.form.emailAddress': 'Email Address',
  'portal.form.company': 'Company',
  'portal.form.plantSelection': 'Plant Selection',
  'portal.form.selectPlant': 'Select Plant',
  'portal.form.noPlantsAvailable': 'No plants available for your account.',
  'portal.form.issueDetails': 'Issue Details',
  'portal.form.issueCategory': 'Issue Category',
  'portal.form.selectCategory': 'Select a category',
  'portal.form.assignedTo': 'Will be assigned to:',
  'portal.form.priorityLevel': 'Priority Level',
  'portal.form.subject': 'Subject',
  'portal.form.subjectPlaceholder': 'Brief summary of the issue',
  'portal.form.description': 'Detailed Description',
  'portal.form.descriptionPlaceholder': 'Please provide a detailed description of the issue...',
  'portal.form.attachments': 'Attachments',
  'portal.form.attachmentsOptional': 'Optional',
  'portal.form.dragDrop': 'Drag and drop files here, or click to browse',
  'portal.form.chooseFiles': 'Choose Files',
  'portal.form.supportedFormats': 'Supported: PDF, Images, Excel, Word (Max 10MB per file)',
  'portal.form.contactPreference': 'Contact Preference',
  'portal.form.preferredMethod': 'Preferred Contact Method',
  'portal.form.confirmAccuracyText': 'I confirm that the information provided is accurate and complete. I understand that this ticket will be processed according to the priority level selected.',
  'portal.form.submitting': 'Submitting...',
  'portal.form.submitTicket': 'Submit Service Ticket',
  'portal.form.submitError': 'Failed to submit ticket. Please try again.',

  // Submit Success
  'portal.success.title': 'Ticket Submitted Successfully!',
  'portal.success.subtitle': 'Your service request has been received and will be processed shortly.',
  'portal.success.ticketId': 'Ticket ID',
  'portal.success.status': 'Status',
  'portal.success.submittedBy': 'Submitted By',
  'portal.success.plants': 'Plant(s)',
  'portal.success.category': 'Category',
  'portal.success.priority': 'Priority',
  'portal.success.department': 'Assigned Department',
  'portal.success.expectedResponse': 'Expected First Response',
  'portal.success.subject': 'Subject',
  'portal.success.whatNext': 'What happens next?',
  'portal.success.nextItem1': 'Your ticket has been assigned to the {{dept}} department',
  'portal.success.nextItem2': 'You will receive updates via {{method}}',
  'portal.success.nextItem3': 'Expected first response: {{time}}',
  'portal.success.nextItem4': 'Keep your ticket ID for reference: <strong>{{id}}</strong>',
  'portal.success.submitAnother': 'Submit Another Ticket',

  // Track
  'portal.track.title': 'Track Your Ticket',
  'portal.track.description': 'Enter the ticket ID with the format <strong>TK-000</strong> (the one you received when creating the ticket).',
  'portal.track.ticketNumberLabel': 'Ticket Number',
  'portal.track.placeholder': 'e.g.: TK-001',
  'portal.track.searching': 'Searching...',
  'portal.track.trackBtn': 'Track Ticket',
  'portal.track.ticketDetails': 'Ticket Details',
  'portal.track.searchAnother': 'Search Another',
  'portal.track.client': 'Client',
  'portal.track.plant': 'Plant',
  'portal.track.category': 'Category',
  'portal.track.priority': 'Priority',
  'portal.track.submittedOn': 'Submitted On',
  'portal.track.expectedResolution': 'Expected Resolution',
  'portal.track.resolvedOn': 'Resolved On',
  'portal.track.notAvailable': 'Not available',
  'portal.track.resolved.title': 'Ticket Resolved',
  'portal.track.resolved.description': 'This ticket has been successfully resolved. If you have any further questions, please submit a new ticket.',
  'portal.track.activityTimeline': 'Activity Timeline',
  'portal.track.notFound.title': 'Ticket Not Found',
  'portal.track.notFound.description': 'We could not find a ticket <strong>{{id}}</strong>. Check the format (TK-001).',
  'portal.track.notFound.tips': 'Tips',
  'portal.track.notFound.tip1': 'You must use the format <strong>TK-000</strong>, not just the number',
  'portal.track.notFound.tip2': 'It is the same code shown when submitting the ticket',
  'portal.track.tryAgain': 'Try Again',

  // Portal Login
  'portal.login.title': 'Client Portal',
  'portal.login.subtitle': 'Sign in to view your tickets',
  'portal.login.emailLabel': 'Email Address',
  'portal.login.emailPlaceholder': 'your.email@company.com',
  'portal.login.passwordLabel': 'Password',
  'portal.login.passwordPlaceholder': 'Enter your password',
  'portal.login.error401': 'Invalid email or password, or your account is inactive. Please try again.',
  'portal.login.error403': 'Your account is not authorized to access the portal. Please contact your Cysol representative.',
  'portal.login.errorGeneric': 'Login failed. Please try again later.',
  'portal.login.signingIn': 'Signing in...',
  'portal.login.signIn': 'Sign In to Portal',

  // My Portal (ClientTicketPortal)
  'portal.myPortal.clientContact': 'Client Contact',
  'portal.myPortal.newTicket': 'New Ticket',
  'portal.myPortal.signOut': 'Sign Out',
  'portal.myPortal.totalTickets': 'Total Tickets',
  'portal.myPortal.open': 'Open',
  'portal.myPortal.escalated': 'Escalated',
  'portal.myPortal.resolved': 'Resolved',
  'portal.myPortal.escalationAlert': '{{count}} Overdue Ticket(s) Require Attention',
  'portal.myPortal.urgent': 'URGENT',
  'portal.myPortal.escalationDesc': 'The following tickets have exceeded their SLA deadline. Our team is working to resolve them as a top priority.',
  'portal.myPortal.myTickets': 'My Tickets',
  'portal.myPortal.searchPlaceholder': 'Search by TK-001, title or plant...',
  'portal.myPortal.allStatuses': 'All Statuses',
  'portal.myPortal.noTickets': 'No tickets found',
  'portal.myPortal.adjustFilters': 'Try adjusting your filters',
  'portal.myPortal.showing': 'Showing {{count}} of {{total}} tickets',
  'portal.myPortal.submitNewTicket': 'Submit new ticket',
  'portal.myPortal.overdue': 'Overdue',
  'portal.myPortal.hoursOverdue': '{{hours}}h overdue',
  'portal.myPortal.loadingTickets': 'Loading tickets...',

  // My Portal - Ticket Detail
  'portal.myPortal.detail.backToTickets': 'Back to My Tickets',
  'portal.myPortal.detail.plant': 'Plant',
  'portal.myPortal.detail.category': 'Category',
  'portal.myPortal.detail.department': 'Department',
  'portal.myPortal.detail.assignedTo': 'Assigned To',
  'portal.myPortal.detail.unassigned': 'Unassigned',
  'portal.myPortal.detail.submitted': 'Submitted',
  'portal.myPortal.detail.priority': 'Priority',
  'portal.myPortal.detail.slaOverdue': 'SLA Overdue — Escalated',
  'portal.myPortal.detail.slaOverdueDesc': 'This ticket is <strong>{{hours}} hours overdue</strong>. It has been escalated to management and is being handled with top priority.',
  'portal.myPortal.detail.ticketResolved': 'Ticket Resolved',
  'portal.myPortal.detail.resolvedOn': 'Resolved on {{date}}.',
  'portal.myPortal.detail.activityTimeline': 'Activity Timeline',
  'portal.myPortal.detail.events': '{{count}} events',
  'portal.myPortal.detail.ticketClosed': 'Ticket Closed \u2014 Awaiting Your Review',
  'portal.myPortal.detail.ticketClosedDesc': 'Our team has closed this ticket. Please confirm it was resolved or request a reopening if the issue persists.',
  'portal.myPortal.detail.reviewOrReopen': 'Confirm or Reopen',

  // My Portal - New Ticket Form
  'portal.myPortal.newForm.title': 'New Ticket',
  'portal.myPortal.newForm.reporterInfo': 'Reporter Information (pre-filled)',
  'portal.myPortal.newForm.name': 'Name',
  'portal.myPortal.newForm.email': 'Email',
  'portal.myPortal.newForm.company': 'Company',
  'portal.myPortal.newForm.role': 'Role',
  'portal.myPortal.newForm.clientContact': 'Client Contact',
  'portal.myPortal.newForm.plant': 'Plant',
  'portal.myPortal.newForm.issueCategory': 'Issue Category',
  'portal.myPortal.newForm.selectCategory': 'Select a category',
  'portal.myPortal.newForm.assignedTo': 'Assigned to:',
  'portal.myPortal.newForm.priority': 'Priority',
  'portal.myPortal.newForm.subject': 'Subject',
  'portal.myPortal.newForm.subjectPlaceholder': 'Brief summary of the issue',
  'portal.myPortal.newForm.description': 'Description',
  'portal.myPortal.newForm.descriptionPlaceholder': 'Describe the issue in detail...',
  'portal.myPortal.newForm.attachments': 'Attachments',
  'portal.myPortal.newForm.attachmentsOptional': 'optional',
  'portal.myPortal.newForm.dropFiles': 'Drop files here or <1>browse</1>',
  'portal.myPortal.newForm.dropFilesText': 'Drop files here or',
  'portal.myPortal.newForm.browse': 'browse',
  'portal.myPortal.newForm.fileFormats': 'PDF, Images, Excel, Word — max 10 MB each',
  'portal.myPortal.newForm.filesSelected': '{{count}} file(s) selected',
  'portal.myPortal.newForm.ticketFor': 'Ticket will be submitted for:',
  'portal.myPortal.newForm.submitting': 'Submitting...',
  'portal.myPortal.newForm.submitTicket': 'Submit Ticket',
  'portal.myPortal.newForm.submitError': 'Failed to submit ticket. Please try again.',
  'portal.myPortal.newForm.success.title': 'Ticket Submitted!',
  'portal.myPortal.newForm.success.subtitle': 'Your request has been received and assigned to our team.',
  'portal.myPortal.newForm.success.ticketId': 'Your Ticket ID',
  'portal.myPortal.newForm.success.filesAttached': '{{count}} file(s) attached',
  'portal.myPortal.newForm.success.confirmationSent': 'A confirmation has been sent to <strong>{{email}}</strong>',
  'portal.myPortal.newForm.success.backToTickets': 'Back to My Tickets',
  'portal.myPortal.newForm.loadingFormData': 'Loading form data...',

  // ──────────────────────────────────────────────
  // CREATE TICKET (Admin)
  // ──────────────────────────────────────────────
  'createTicket.subtitle': 'Submit a complaint or service request for your industrial plant',
  'createTicket.backToTickets': 'Back to Tickets',
  'createTicket.ticketTargetType': 'What is this ticket for?',
  'createTicket.ticketTargetTypeHint':
    'Choose a client plant, or an internal department queue (no client/plant on the ticket).',
  'createTicket.targetClient': 'Client company & plant',
  'createTicket.targetInternalDepartment': 'Internal department',
  'createTicket.internalDeptSection': 'Internal department',
  'createTicket.internalDeptHelp':
    'The ticket is queued for this area. The first available user in that department is auto-assigned when possible; otherwise it stays unassigned.',
  'createTicket.internalDepartment': 'Department',
  'createTicket.selectInternalDepartment': 'Select a department',
  'createTicket.categoryHintInternal':
    'Category does not change the department on internal tickets — use the department you selected above.',
  'createTicket.internalDeptLocked': 'Department: {{name}} (from your selection above)',
  'createTicket.contactNotApplicableInternal': 'Not applicable — internal ticket (no client contact).',
  'createTicket.validation.internalDepartmentRequired': 'Select a department for the internal ticket.',
  'createTicket.clientInfo': 'Client Information',
  'createTicket.clientCompany': 'Client Company',
  'createTicket.selectClient': 'Select a client',
  'createTicket.plantSelection': 'Plant Selection',
  'createTicket.howManyPlants': 'How many plants does this ticket affect?',
  'createTicket.singlePlant': 'Single Plant',
  'createTicket.multiplePlants': 'Multiple Plants',
  'createTicket.selectClientFirst': 'Select a client first',
  'createTicket.selectClientFirstPlants': 'Select a client first to see available plants',
  'createTicket.noPlantsFound': 'No plants found for this client',
  'createTicket.selectPlants': 'Select Plant(s)',
  'createTicket.ticketDetails': 'Ticket Details',
  'createTicket.category': 'Category',
  'createTicket.selectCategory': 'Select a category',
  'createTicket.assignedToDept': 'Will be assigned to:',
  'createTicket.department': 'Department',
  'createTicket.selectDepartment': 'Select a department',
  'createTicket.assignee': 'Assignee',
  'createTicket.autoAssigned': 'Auto-assigned',
  'createTicket.otherDepartments': 'Other departments',
  'createTicket.selectAssignee': 'Select an assignee',
  'createTicket.contact': 'Contact',
  'createTicket.selectContact': 'Select a contact',
  'createTicket.noContactsFound': 'No contacts found for this client',
  'createTicket.selectClientFirstContacts': 'Select a client first',
  'createTicket.priority': 'Priority',
  'createTicket.estimatedResponse': 'Estimated response time:',
  'createTicket.subject': 'Subject',
  'createTicket.subjectPlaceholder': 'Brief summary of the issue',
  'createTicket.description': 'Detailed Description',
  'createTicket.descriptionPlaceholder': 'Provide a detailed description of the issue, including any relevant context, impact, and urgency...',
  'createTicket.attachments': 'Attachments',
  'createTicket.attachmentsOptional': 'Optional',
  'createTicket.dragDrop': 'Drag and drop files here, or click to browse',
  'createTicket.chooseFiles': 'Choose Files',
  'createTicket.supportedFormats': 'Supported: PDF, Images, Excel, Word (Max 10MB per file)',
  'createTicket.cancel': 'Cancel',
  'createTicket.creating': 'Creating...',
  'createTicket.creatingTicket': 'Creating ticket...',
  'createTicket.creatingForPlant': 'Creating ticket for {{plant}} ({{current}}/{{total}})...',
  'createTicket.uploadingAttachments': 'Uploading attachments...',
  'createTicket.uploadingFile': 'Uploading file {{current}} of {{total}}: {{name}}',
  'createTicket.uploadComplete': 'Uploaded successfully',
  'createTicket.uploadFailed': 'Failed to upload',
  'createTicket.uploadPartialWarning': 'Ticket created, but {{count}} file(s) failed to upload. You can retry from the ticket detail page.',
  'createTicket.loading': 'Loading...',
  'createTicket.createTicket': 'Create Ticket',
  'createTicket.retry': 'Retry',
  'createTicket.unknownError': 'Unknown error',
  'createTicket.createFailed': 'Failed to create ticket',
  'createTicket.loadError': 'Failed to load form data: {{msg}}. Make sure the API is running and you are logged in.',
  'createTicket.success.title': 'Ticket Created Successfully!',
  'createTicket.success.subtitle': 'Your complaint has been submitted and assigned to the appropriate team.',
  'createTicket.success.ticketId': 'Ticket ID',
  'createTicket.success.status': 'Status',
  'createTicket.success.client': 'Client',
  'createTicket.success.internalClientLabel': 'Internal (no client)',
  'createTicket.success.internalPlantLabel': '—',
  'createTicket.success.plants': 'Plant(s)',
  'createTicket.success.category': 'Category',
  'createTicket.success.priority': 'Priority',
  'createTicket.success.department': 'Assigned Department',
  'createTicket.success.estimatedResponse': 'Estimated Response',
  'createTicket.success.subject': 'Subject',
  'createTicket.success.whatNext': 'What happens next?',
  'createTicket.success.nextItem1': 'The assigned department has been notified',
  'createTicket.success.nextItem2': 'You will receive updates via email',
  'createTicket.success.nextItem3': 'Track progress in the Tickets section',
  'createTicket.success.nextItem4': 'Expected first response: {{time}}',
  'createTicket.success.viewAllTickets': 'View All Tickets',
  'createTicket.success.createAnother': 'Create Another Ticket',

  // ──────────────────────────────────────────────
  // SERVICE TYPES
  // ──────────────────────────────────────────────
  'serviceTypes.title': 'Service Types',
  'serviceTypes.subtitle': 'Manage available service types',
  'serviceTypes.addNew': 'Add Service Type',
  'serviceTypes.manageDesc': 'Manage the catalogue of services offered in contracts',
  'serviceTypes.addModalDesc': 'Add a new service type to the catalogue',
  'serviceTypes.keyHint': 'Used internally in contracts. Lowercase, hyphens only.',
  'serviceTypes.namePlaceholder': 'e.g. Industrial Cleaning',
  'serviceTypes.keyPlaceholder': 'e.g. industrial-cleaning',
  'serviceTypes.descPlaceholder': 'Brief description of this service type…',
  'serviceTypes.notFoundTitle': 'No service types found',
  'serviceTypes.notFoundDesc': 'Try adjusting your search or filters',
  'serviceTypes.newBtn': 'New Service Type',
  'serviceTypes.stats.totalTypes': 'Total Types',
  'serviceTypes.stats.active': 'Active',
  'serviceTypes.stats.inactive': 'Inactive',
  'serviceTypes.allStatuses': 'All Statuses',
  'serviceTypes.clear': 'Clear',
  'serviceTypes.countOf': '{{shown}} of {{total}}',
  'serviceTypes.col.serviceType': 'Service Type',
  'serviceTypes.col.key': 'Key',
  'serviceTypes.col.description': 'Description',
  'serviceTypes.col.status': 'Status',
  'serviceTypes.col.created': 'Created',
  'serviceTypes.col.actions': 'Actions',
  'serviceTypes.showingTypes': 'Showing {{shown}} of {{total}} service types',
  'serviceTypes.modal.newTitle': 'New Service Type',
  'serviceTypes.modal.editTitle': 'Edit Service Type',
  'serviceTypes.form.name': 'Name',
  'serviceTypes.form.key': 'Key (slug)',
  'serviceTypes.form.description': 'Description',
  'serviceTypes.form.icon': 'Icon',
  'serviceTypes.form.color': 'Color',
  'serviceTypes.form.preview': 'Preview:',
  'serviceTypes.form.previewFallback': 'Service Type',
  'serviceTypes.form.status': 'Status',
  'serviceTypes.createBtn': 'Create Service Type',
  'serviceTypes.deleteTitle': 'Delete Service Type',
  'serviceTypes.deleteConfirm':
    'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
  'serviceTypes.err.statusUpdate': 'Error updating status',
  'serviceTypes.err.load': 'Error loading service types',
  'serviceTypes.err.create': 'Error creating service type',
  'serviceTypes.err.update': 'Error updating service type',
  'serviceTypes.err.delete': 'Error deleting service type',
  'serviceTypes.searchPlaceholder': 'Search by name, key or description…',
  'serviceTypes.deleting': 'Deleting…',
  'serviceTypes.icon.water': 'Water / Cleaning',
  'serviceTypes.icon.tools': 'Tools',
  'serviceTypes.icon.shield': 'Shield',
  'serviceTypes.icon.graduation': 'Graduation Cap',
  'serviceTypes.icon.lightbulb': 'Lightbulb',
  'serviceTypes.icon.hammer': 'Hammer',
  'serviceTypes.icon.settings': 'Settings',
  'serviceTypes.icon.recycle': 'Recycle',
  'serviceTypes.icon.leaf': 'Leaf',
  'serviceTypes.icon.barChart': 'Bar Chart',
  'serviceTypes.icon.fileText': 'File Text',
  'serviceTypes.icon.alert': 'Alert',

  // ──────────────────────────────────────────────
  // PROFILE MODAL
  // ──────────────────────────────────────────────
  'profile.err.nameRequired': 'Name is required',
  'profile.err.emailRequired': 'Email is required',
  'profile.err.emailInvalid': 'Invalid email format',
  'profile.err.newPasswordRequired': 'New password is required',
  'profile.err.passwordMin8': 'Password must be at least 8 characters',
  'profile.err.confirmPassword': 'Please confirm your password',
  'profile.err.passwordMismatch': 'Passwords do not match',
  'profile.toast.updated': 'Profile updated successfully',
  'profile.toast.updateFailed': 'Failed to update profile',
  'profile.toast.comingSoon': 'Coming soon',
  'profile.prefs.emailNotifications': 'Email Notifications',
  'profile.prefs.emailNotificationsDesc': 'Receive email updates for all activities',
  'profile.prefs.escalationAlerts': 'Escalation Alerts',
  'profile.prefs.escalationAlertsDesc': 'Get notified when tickets are escalated',
  'profile.prefs.ticketAssignments': 'Ticket Assignments',
  'profile.prefs.ticketAssignmentsDesc': 'Notify me when tickets are assigned to me',
  'profile.prefs.weeklyDigest': 'Weekly Digest',
  'profile.prefs.weeklyDigestDesc': 'Receive a weekly summary of all activities',
  'profile.prefs.clientUpdates': 'Client Updates',
  'profile.prefs.clientUpdatesDesc': 'Get notified of client-visible updates',
  'profile.changePhoto': 'Change Photo',
  'profile.editTitle': 'Edit Profile',
  'profile.imageAlt': 'Profile',
  'profile.currentPasswordPlaceholder': 'Enter current password to change',
  'profile.sectionPersonal': 'Personal Information',
  'profile.sectionNotifications': 'Notification Preferences',
  'profile.sectionSecurity': 'Security',
  'profile.phoneNumber': 'Phone Number',
  'profile.jobTitle': 'Job Title',
  'profile.photoHint': 'JPG, PNG or GIF. Max 2MB.',
  'profile.currentPassword': 'Current Password',
  'profile.passwordHintMin8': 'Password must be at least 8 characters long',

  // ──────────────────────────────────────────────
  // REPORTS
  // ──────────────────────────────────────────────
  'reports.title': 'Reports',
  'reports.subtitle': 'Analytics and reports for the ticket system',
  'reports.metricsSubtitle': 'Comprehensive metrics and performance analysis',
  'reports.exportReport': 'Export Report',
  'reports.loading': 'Loading reports…',
  'reports.loadError': 'Error loading reports',
  'reports.periodLabel': 'Report Period:',
  'reports.periodLast4Weeks': 'Last 4 Weeks',
  'reports.periodLast5Months': 'Last 5 Months',
  'reports.periodCustom': 'Custom Range',
  'reports.dateTo': 'to',
  'reports.kpi.totalTickets': 'Total Tickets',
  'reports.kpi.thisPeriod': 'This period',
  'reports.kpi.resolutionRate': 'Resolution Rate',
  'reports.kpi.resolvedOf': '{{resolved}} of {{total}} resolved',
  'reports.kpi.avgResolution': 'Avg Resolution Time',
  'reports.kpi.avgAcrossTickets': 'Average across all tickets',
  'reports.kpi.slaCompliance': 'SLA Compliance',
  'reports.kpi.withinSla': 'Within SLA targets',
  'reports.trendTitle': 'Complaints Trend',
  'reports.totalLabel': 'Total:',
  'reports.resolvedLabel': 'Resolved:',
  'reports.openLabel': 'Open:',
  'reports.legendTotal': 'Total Tickets',
  'reports.legendResolved': 'Resolved',
  'reports.legendOpen': 'Open',
  'reports.avgResolutionByCategory': 'Avg Resolution Time by Category',
  'reports.ticketsCount': '{{count}} tickets',
  'reports.complaintsByStatus': 'Complaints by Status',
  'reports.deptPerformance': 'Department Performance',
  'reports.col.department': 'Department',
  'reports.col.ticketsHandled': 'Tickets Handled',
  'reports.col.resolved': 'Resolved',
  'reports.col.completionRate': 'Completion Rate',
  'reports.col.performance': 'Performance',
  'reports.complaintsByPlant': 'Complaints by Plant',
  'reports.topDepts': 'Top Performing Departments',
  'reports.resolvedCount': '{{count}} resolved',
  'reports.totalShort': '{{count}} total',
  'reports.rateLabel': 'Rate: {{rate}}%',
  'reports.escalationTitle': 'Escalation Analysis',
  'reports.atRiskLabel': 'At Risk:',
  'reports.actionRequired': 'Action Required',
  'reports.escalationWarning':
    '{{count}} ticket(s) at risk or overdue. Review workload and resource allocation.',
  'reports.export.summary': 'Summary',
  'reports.export.metricValue': 'Metric,Value',
  'reports.export.totalTickets': 'Total Tickets',
  'reports.export.resolutionRate': 'Resolution Rate',
  'reports.export.avgResolution': 'Avg Resolution Time',
  'reports.export.slaCompliance': 'SLA Compliance',
  'reports.export.statusBreakdown': 'Status Breakdown',
  'reports.export.statusCount': 'Status,Count',
  'reports.export.byCategory': 'By Category',
  'reports.export.categoryRow': 'Category,Total,Open,Resolved,Closed',
  'reports.export.byDepartment': 'By Department',
  'reports.export.deptRow': 'Department,Total,Open,Resolved,Closed',
  'reports.export.byClient': 'By Client',
  'reports.export.clientRow': 'Client,Total,Open,Resolved,Closed',

  // ──────────────────────────────────────────────
  // FILE UPLOAD (shared)
  // ──────────────────────────────────────────────
  'fileUpload.dragDrop': 'Drag and drop files here, or click to browse',
  'fileUpload.chooseFiles': 'Choose Files',
  'fileUpload.supportedAccept': 'Supported: {{accept}} (Max {{maxSize}}MB per file)',
  'fileUpload.allTypesMax': 'All file types supported (Max {{maxSize}}MB per file)',

  // ──────────────────────────────────────────────
  // TICKETS
  // ──────────────────────────────────────────────
  'tickets.title': 'Tickets',
  'tickets.createNew': 'Create New Ticket',
  'tickets.newTicket': 'New Ticket',
  'tickets.allStatus': 'All Status',
  'tickets.allPriorities': 'All Priorities',
  'tickets.allClients': 'All Clients',
  'tickets.loading': 'Loading tickets...',
  'tickets.notFound': 'No tickets found',
  'tickets.subtitle': 'Manage and track all complaint tickets',
  'tickets.export': 'Export Excel',
  'tickets.exportExcel': 'Export Excel',
  'tickets.exporting': 'Exporting...',
  'tickets.exportModal.title': 'Excel export options',
  'tickets.exportModal.desc': 'Other list filters (client, status, scope, etc.) apply when exporting all matching tickets.',
  'tickets.exportModal.ticketScope': 'Which tickets to export?',
  'tickets.exportModal.scopeSelected': 'Selected only',
  'tickets.exportModal.scopeSelectedHint': '{{count}} ticket(s) checked in the table',
  'tickets.exportModal.scopeSelectedEmpty': 'Check tickets in the table to use this option',
  'tickets.exportModal.scopeAllFiltered': 'All matching current filters',
  'tickets.exportModal.scopeAllFilteredHint': 'Up to {{count}} ticket(s) from search and list filters',
  'tickets.exportModal.noSelection': 'Select at least one ticket or choose export all',
  'tickets.exportModal.sheetMode': 'Workbook layout',
  'tickets.exportModal.modeSingle': 'Single sheet',
  'tickets.exportModal.modeByDepartment': 'One sheet per department',
  'tickets.exportModal.modeByCategory': 'One sheet per area (category)',
  'tickets.exportModal.deptScope': 'Departments to include',
  'tickets.exportModal.deptAll': 'All departments (each on its own sheet)',
  'tickets.exportModal.deptOne': 'This department only',
  'tickets.exportModal.catScope': 'Areas to include',
  'tickets.exportModal.catAll': 'All areas (each on its own sheet)',
  'tickets.exportModal.catOne': 'This area only',
  'tickets.exportModal.selectDept': 'Select department',
  'tickets.exportModal.selectCat': 'Select area',
  'tickets.exportModal.confirm': 'Download Excel',
  'tickets.exportModal.unassignedDept': 'Unassigned department',
  'tickets.exportModal.unassignedCat': 'Uncategorized',
  'tickets.exportModal.defaultSheet': 'Tickets',
  'tickets.department': 'Department',
  'tickets.allDepartments': 'All departments',
  'tickets.area': 'Area (category)',
  'tickets.allAreas': 'All areas',
  'tickets.scope': 'Ticket scope',
  'tickets.scopeAll': 'All (open and closed)',
  'tickets.scopeOpen': 'Open / active only',
  'tickets.scopeClosed': 'Closed or resolved only',
  'tickets.createTicket': 'Create Ticket',
  'tickets.filters': 'Filters',
  'tickets.filtersAdvanced': 'Advanced filters',
  'tickets.filtersAdvancedShow': 'Show advanced',
  'tickets.filtersAdvancedHide': 'Hide advanced',
  'tickets.filtersAdvancedActive': '{{count}} advanced filter(s)',
  'tickets.filterMine': 'Only my tickets (assigned to me or created by me)',
  'tickets.filterMineHint': 'Uncheck to list all tickets.',
  'tickets.clearAll': 'Clear all ({{count}})',
  'tickets.searchLabel': 'Search',
  'tickets.searchPlaceholder': 'Search by ID, title, client, plant...',
  'tickets.client': 'Client',
  'tickets.plant': 'Plant',
  'tickets.status': 'Status',
  'tickets.priority': 'Priority',
  'tickets.itemsPerPage': 'Items per page',
  'tickets.allPlants': 'All Plants',
  'tickets.selectedCount': '{{count}} ticket(s) selected',
  'tickets.assign': 'Assign',
  'tickets.changeStatus': 'Change Status',
  'tickets.col.ticketId': 'Ticket ID',
  'tickets.col.title': 'Title',
  'tickets.col.category': 'Category',
  'tickets.col.owner': 'Owner',
  'tickets.col.sla': 'SLA',
  'tickets.col.actions': 'Actions',
  'tickets.view': 'View',
  'tickets.hoursOverdue': '{{hours}}h overdue',
  'tickets.hoursLeft': '{{hours}}h left',
  'tickets.bulk.assignTitle': 'Assign Tickets',
  'tickets.bulk.assignDesc': 'Select an owner for {{count}} ticket(s)',
  'tickets.bulk.assignFilteredHint':
    'User list is limited to the department shared by all selected tickets (same rule as assigning from ticket detail).',
  'tickets.bulk.selectOwner': 'Select owner...',
  'tickets.bulk.cancel': 'Cancel',
  'tickets.bulk.assigning': 'Assigning...',
  'tickets.bulk.assignBtn': 'Assign',
  'tickets.bulk.statusTitle': 'Change Status',
  'tickets.bulk.statusDesc':
    'Only statuses allowed for every selected ticket are shown (same transitions as the ticket detail page).',
  'tickets.bulk.statusNoCommon':
    'There is no common next status for all selected tickets (for example, closed tickets cannot be changed here).',
  'tickets.bulk.selectStatus': 'Select status...',
  'tickets.bulk.updating': 'Updating...',
  'tickets.bulk.statusBtn': 'Change Status',
  'tickets.exportCols': 'ID,Title,Client,Plant,Status,Priority,Owner,Created',
  'tickets.exportColsExcel':
    'ID,Number,Title,Client,Plant,Category,Department,Status,Priority,Owner,SLA,Created',
  'tickets.toast.exportEmpty': 'No tickets to export with the current filters',
  'tickets.toast.exportFail': 'Failed to export tickets',
  'tickets.toast.assignOk': 'Assigned {{count}} ticket(s) successfully',
  'tickets.toast.assignFail': 'Failed to assign tickets',
  'tickets.toast.statusNotAllowed': 'That status is not allowed for all selected tickets',
  'tickets.toast.statusOk': 'Status changed for {{count}} ticket(s) successfully',
  'tickets.toast.statusFail': 'Failed to change status',
  'tickets.toast.exportOk': '{{count}} ticket(s) exported',
  'tickets.toast.exportAllOk': 'Exported {{count}} ticket(s) across {{sheets}} Excel sheet(s)',
  'tickets.toast.filtersCleared': 'All filters cleared',
  'tickets.toast.selectOne': 'Please select at least one ticket',
  'tickets.toast.loadFail': 'Failed to load tickets',
  'tickets.emptyTitle': 'No tickets found',
  'tickets.emptyDesc': 'No tickets match your current filters. Try adjusting your search criteria.',
  'tickets.clearFilters': 'Clear Filters',

  // ──────────────────────────────────────────────
  // TICKET DETAIL
  // ──────────────────────────────────────────────
  'ticketDetail.loading': 'Loading ticket...',
  'ticketDetail.notFoundTitle': 'Ticket Not Found',
  'ticketDetail.notFoundDesc': "The ticket you're looking for doesn't exist.",
  'ticketDetail.backToTickets': 'Back to Tickets',
  'ticketDetail.printedOn': 'Printed on {{date}}',
  'ticketDetail.printTicket': 'TICKET {{id}}',
  'ticketDetail.attachments': 'Attachments',
  'ticketDetail.activityTimeline': 'Activity Timeline',
  'ticketDetail.escalatedBanner': 'Escalated Ticket',
  'ticketDetail.clientUpdates': 'Client-Visible Updates',
  'ticketDetail.internalNotes': 'Internal Notes',
  'ticketDetail.clientUpdatePlaceholder': 'Write an update that will be visible to the client...',
  'ticketDetail.internalNotePlaceholder': 'Write an internal note (not visible to client)...',
  'ticketDetail.addClientUpdate': 'Add Client Update',
  'ticketDetail.addInternalNote': 'Add Internal Note',
  'ticketDetail.slaStatus': 'SLA Status',
  'ticketDetail.overdue': 'Overdue',
  'ticketDetail.remaining': 'Remaining',
  'ticketDetail.quickActions': 'Quick Actions',
  'ticketDetail.reassign': 'Reassign Ticket',
  'ticketDetail.reassignToNew': 'Set status to New (keeps full history)',
  'ticketDetail.reassignToNewHint': 'The new owner will see it as a fresh ticket; timeline is preserved.',
  'ticketDetail.reassignEscalate': 'Escalate at the same time',
  'ticketDetail.reassignEscalateHint': 'Ticket will stay in Escalated status and be recorded in history.',
  'ticketDetail.closedAdminOnly': 'Only administrators can close a ticket.',
  'ticketDetail.escalateToDept': 'Department',
  'ticketDetail.escalateToUser': 'User',
  'ticketDetail.selectDepartment': 'Select department',
  'ticketDetail.selectUser': 'Select user',
  'ticketDetail.cancel': 'Cancel',
  'ticketDetail.confirmReassign': 'Confirm Reassign',
  'ticketDetail.closeTicket': 'Close Ticket',
  'ticketDetail.resolutionPlaceholder': 'Describe how the issue was resolved...',
  'ticketDetail.confirmClose': 'Confirm Close',
  'ticketDetail.confirmStatusTitle': 'Confirm Status Change',
  'ticketDetail.confirmStatusBody': 'Change status to <strong>{{status}}</strong>?',
  'ticketDetail.escalateTo': 'Escalate to',
  'ticketDetail.download': 'Download',
  'ticketDetail.delete': 'Delete',
  'ticketDetail.uploadAttach': 'Upload attachment',
  'ticketDetail.dropFiles': 'Drop files or click to upload',
  'ticketDetail.noTimeline': 'No timeline events yet.',
  'ticketDetail.noAttachments': 'No attachments yet.',
  'ticketDetail.createdBy': 'Created By',
  'ticketDetail.createdAt': 'Created At',
  'ticketDetail.estimatedResolution': 'Estimated Resolution',
  'ticketDetail.resolvedAt': 'Resolved At',
  'ticketDetail.slaHoursOverdue': '{{hours}}h Overdue',
  'ticketDetail.slaHoursRemaining': '{{hours}}h Remaining',
  'notFound.title': 'Page not found',
  'notFound.description': "Sorry, the page you're looking for doesn't exist or has been moved.",
  'notFound.goBack': 'Go Back',
  'notFound.goDashboard': 'Go to Dashboard',
  'topbar.justNow': 'just now',
  'topbar.minAgo': '{{count}} min ago',
  'topbar.hourAgo': '{{count}} hour ago',
  'topbar.hoursAgo': '{{count}} hours ago',
  'topbar.dayAgo': '{{count}} day ago',
  'topbar.daysAgo': '{{count}} days ago',
  'topbar.action.create': 'Created',
  'topbar.action.update': 'Updated',
  'topbar.action.delete': 'Deleted',
  'topbar.action.created': 'Created',
  'topbar.action.updated': 'Updated',
  'topbar.action.deleted': 'Deleted',
  'topbar.action.login': 'Logged in',
  'topbar.action.upload_attachment': 'File uploaded',
  'topbar.action.delete_attachment': 'File deleted',
  'topbar.helpSupport': 'Help / Support',
  'topbar.defaultUser': 'User',
  'ticketDetail.invalidId': 'Invalid ticket ID',
  'ticketDetail.loadError': 'Could not load ticket',
  'ticketDetail.noDescription': 'No description provided',
  'ticketDetail.noDescriptionShort': 'No description',
  'ticketDetail.printFooter': 'Cysol Ticket Management System • {{id}}',
  'ticketDetail.system': 'System',
  'ticketDetail.internalBadge': 'Internal',
  'ticketDetail.postClientUpdateBtn': 'Post Client Update',
  'ticketDetail.assignTo': 'Assign to',
  'ticketDetail.reassignAction': 'Reassign',
  'ticketDetail.closeTicketAction': 'Close Ticket',
  'ticketDetail.uploadFile': 'Upload File',
  'ticketDetail.printTicketBtn': 'Print Ticket',
  'ticketDetail.shareTicket': 'Share Ticket',
  'ticketDetail.duplicateTicket': 'Duplicate Ticket',
  'ticketDetail.resolutionSummaryLabel': 'Resolution Summary',
  'ticketDetail.confirmStatusChangeFromTo':
    'Are you sure you want to change the status from {{from}} to {{to}}?',
  'ticketDetail.confirmBtn': 'Confirm',
  'ticketDetail.escalateTicketTitle': 'Escalate Ticket',
  'ticketDetail.escalateTicketIntro':
    'Specify who this ticket is being escalated to. This will be recorded in the ticket history.',
  'ticketDetail.escalateBtn': 'Escalate',
  'ticketDetail.escWarnEscWithHours':
    'This ticket is escalated and {{hours}} hours overdue. Requires immediate attention.',
  'ticketDetail.escWarnEscNoHours': 'This ticket is escalated. Requires immediate attention.',
  'ticketDetail.escWarnInProgress':
    'This ticket was escalated and is now in progress. It remains marked as escalated in the history.',
  'ticketDetail.commentDept': 'Department: {{name}}',
  'ticketDetail.commentUser': 'User: {{name}}',
  'ticketDetail.userRef': 'User #{{id}}',
  'ticketDetail.contactRef': 'Contact #{{id}}',
  'ticketDetail.reassignSameOwner':
    'This ticket is already assigned to that person. Choose another assignee to reassign.',
  'ticketDetail.reassignFail': 'Could not reassign the ticket. Please try again.',
  'ticketDetail.reassignOk': 'Ticket reassigned successfully.',
  'ticketDetail.reassignEscalationRequired': 'Select a department or user to escalate to.',
  'ticketDetail.confirmReassignBtn': 'Reassign',
  'common.unitBytes': 'B',
  'common.unitKb': 'KB',
  'common.unitMb': 'MB',
  'ticketDrawer.title': 'Ticket Details',
  'ticketDrawer.slaOverdueTitle': 'SLA Overdue',
  'ticketDrawer.slaOverdueDesc': 'This ticket is {{hours}} hours overdue and requires immediate attention.',
  'ticketDrawer.close': 'Close',
  'ticketDrawer.viewFull': 'View Full Ticket',
  'ticketDrawer.assignedTo': 'Assigned To',
};

export default en;
